'use client';

export { GuestAuthProvider as TourAuthProvider } from '@/platform/auth/AuthContext';
